import { useState, type KeyboardEvent } from "react";
import type { MenuSection } from "../../content/industry";
import { SectionHeading } from "./SectionHeading";

/** Carta con categorías en pestañas accesibles (flechas izquierda/derecha para cambiar de categoría). */
export function MenuBoard({ section }: { section: MenuSection }) {
  const [active, setActive] = useState(0);
  const category = section.categories[active] ?? section.categories[0];
  const move = (event: KeyboardEvent, index: number) => {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
    const next = (index + (event.key === "ArrowRight" ? 1 : -1) + section.categories.length) % section.categories.length;
    setActive(next);
    document.getElementById(`${section.id}-tab-${next}`)?.focus();
  };
  if (!category) return null;
  return (
    <section id={section.id} className="ix-section ix-menu" aria-labelledby={`${section.id}-title`}>
      <div className="ix-container">
        <SectionHeading id={section.id} eyebrow={section.eyebrow} title={section.title} text={section.text} />
        <div className="ix-tabs" role="tablist" aria-label="Categorías de la carta">
          {section.categories.map((item, index) => <button key={item.name} type="button" role="tab" id={`${section.id}-tab-${index}`}
            aria-selected={index === active} aria-controls={`${section.id}-panel`} tabIndex={index === active ? 0 : -1}
            onClick={() => setActive(index)} onKeyDown={event => move(event, index)}>{item.name}</button>)}
        </div>
        <div id={`${section.id}-panel`} role="tabpanel" aria-labelledby={`${section.id}-tab-${active}`} className="ix-menu-panel">
          <ul className="ix-menu-list">{category.items.map(item => <li key={item.name}>
            <div className="ix-service-line"><h3>{item.name}</h3><span aria-hidden="true" className="ix-leader" /><strong>{item.price}</strong></div>
            <p>{item.text}</p>
            {item.tags?.length ? <ul className="ix-tags">{item.tags.map(tag => <li key={tag}>{tag}</li>)}</ul> : null}
          </li>)}</ul>
        </div>
        <p className="ix-note">{section.note}</p>
      </div>
    </section>
  );
}
